import { compose } from 'recompose';
import { queryGetAllTicketNumbersGQL } from '../graphql/GetAllTicketNumbers';
import { createTicketNumberGQL } from '../graphql/CreateTicketNumbersApi';
import { TicketInput } from '..';

const enhance = compose(
  queryGetAllTicketNumbersGQL,
  createTicketNumberGQL,
);

export default enhance(TicketInput);
